/**
 * Dev environment
 *
 * Put what you like in it, but DON'T use it to build prod !
 */
export const environment = {
  production: false,
  title: 'ويزشات، دردشة بلا حدود',
  api: 'https://chat-api-new-pp.contactdve.com/api',
  chat: 'https://pp-chat-liveengine.contactdve.com/',
  extCode: 'EG',
  key: 1,
  newsSectionUrl: null,
  footerText: null,
  footerLinks: [
    { value: 'إدارة اشتراكاتي', href: 'http://www.my-subscriptions-eg.com/' },
  ],
  LP: 'http://promo.weezchat-eg.com/pwzchateg/lp_weetic/',
  redirectIfNoIframe: null,
  useBothSignUpMethod: true,
  avatarSize: 500,
  gtm: 'GTM-P754KZ',
  showAllCities: true,
  completeProfileInputs: ['phoneNumber'],
  RTL: true,
  unsubscribeLink: 'http://www.my-subscriptions-eg.com/',
freeSubscription : false,
  home: {
    app: {
      available: true,
      linkGoogle: 'https://play.google.com/store/apps/details?id=com.virgoplay.weezchatAr',
      linkApple: '',
    },
    facebook: {
      available: true,
      link: 'https://www.facebook.com/WeezchatEG/'
    },
    twitter: {
      available: false,
      link: ''
    },
    instagram: {
      available: true,
      link: 'https://www.instagram.com/weezchat_egypt/'
    }
  },
  RGPD : {
    cookies: {
      available: true,
      link: 'https://www.dgp-legal.com/en/cookies-information/'
    }
  }
};
